"use client";

import { ReactNode } from "react";
import { DropdownMenuItem } from "visuais";

interface MenuItemProps {
  children: ReactNode;
  icon: ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
}

export function MenuItem({
  children,
  icon,
  disabled = false,
  onClick,
  className = "w-full flex justify-between pr-0",
}: MenuItemProps) {
  return (
    <DropdownMenuItem
      className={className}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
      {icon}
    </DropdownMenuItem>
  );
}
